<div class="dropdown">
    <div class="ng-content-area">
        <ng-content></ng-content>
    </div>
    <div *ngIf="isDropdownOpen" [class.dropdown-opened]="isDropdownOpen" class="dropdown-content"
        (mouseleave)="closeDropdown()">
        <div *ngFor="let company of companies; let i = index" class="dropdown-item" (click)="routeToCompany(company)"
            (mouseenter)="toggleProductDropdown(i)" (mouseleave)="closeProductDropdown(i)">
            <div class="dropdown-item-content">
                <h3>{{ company.name }}</h3>
                <i *ngIf="company.products?.length > 0" class="fas fa-chevron-right caret-icon"></i>
            </div>
            <div class="nested-dropdown-wrapper">
                <app-dropdown-menu #dropdownMenus *ngIf="company.products?.length > 0"
                    [dropdownParent]="dropdownMenuParent" [productLines]="company.products"
                    (dropdownClosed)="closeDropdown()">
                </app-dropdown-menu>
            </div>
        </div>
    </div>